import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { ApiService} from '../../../../core/service/api.service';

@Injectable()
export class AttemptProviderChangeService {

  constructor(private api:ApiService) { }

    getAttemptsProvChangeList(criteria): Observable<any> {
        return this.api.get('vna/attempts-provider-change',criteria);
    }

    postAttemptsProvChange(element: Object): Observable<any> {
        return this.api.post('vna/attempts-provider-change', element);
    }
    removeAttemptsProvChange(pk: number): Observable<any> {
        return this.api.remove('vna/attempts-provider-change', pk);
    }
    putAttemptsProvChange(element: any): Observable<any> {
        return this.api.put('vna/attempts-provider-change',element.pk,element);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/attempt-provider-change.service.ts